import { createFileRoute, Link } from "@tanstack/react-router";

const CatchAllPage = () => {
  return (
    <div className="isolate min-h-full">
      <div className="mx-auto max-w-7xl px-6 py-32 text-center sm:py-40 lg:px-8">
        <p className="text-base leading-8 font-semibold text-content-strong">404</p>

        <h1 className="mt-4 text-3xl font-bold tracking-tight text-content-strong sm:text-5xl">
          Page not found
        </h1>

        <p className="mt-4 text-base text-content-muted sm:mt-6">
          Sorry, we couldn’t find the page you’re looking for.
        </p>

        <div className="mt-10 flex justify-center">
          <Link className="text-sm leading-7 font-semibold text-content-strong" to="/">
            <span aria-hidden="true">&larr;</span> Back to home
          </Link>
        </div>
      </div>
    </div>
  );
};

export const Route = createFileRoute("/_private/$")({ component: CatchAllPage });
